var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"mr-2",attrs:{"size":"24"}},[(_vm.photo)?_c('v-img',{attrs:{"src":_vm.photoURL,"alt":"Avatar","width":"24","height":"24"}}):_c('v-icon',[_vm._v("mdi-account-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }